let WoodcraftConstants = {};

// Pricing Constants
WoodcraftConstants.STARTING_AT = 'STARTING AT';
WoodcraftConstants.DOLLAR_SIGN = '$';
WoodcraftConstants.CURRENCY_SEPARATOR = '.';
WoodcraftConstants.WAS = 'Was',
WoodcraftConstants.SAVE = 'Save',
WoodcraftConstants.PERCENT_OFF = '% off';
WoodcraftConstants.OPTIONS = 'Options';

// Review Constants
WoodcraftConstants.ZERO_REVIEWS = '(0 Reviews)';
WoodcraftConstants.REVIEW = 'Review';
WoodcraftConstants.REVIEWS = 'Reviews';

export default WoodcraftConstants;
